import React, { useState, useEffect, useRef,useCallback } from 'react';
import { Modal, Input, Button, List, Avatar, Typography, message } from 'antd';
import { SendOutlined, UserOutlined } from '@ant-design/icons';
import { SUPPORT_API } from '../constants/api';
import axiosInstance from '../services/axiosConfig';

const { Text } = Typography;

const SupportDetail = ({ support, visible, onClose }) => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [messageText, setMessageText] = useState('');
  const messagesEndRef = useRef(null);

  // Hàm format thời gian tương tự như SupportList.js
  const formatDate = (date) => {
    if (!date) return '-';
    
    try {
      // Parse thời gian từ chuỗi ISO "2025-05-23T13:42:43.533Z"
      const dateStr = date.toString();
      
      if (dateStr.includes('T')) {
        // Xử lý format ISO: "2025-05-23T13:42:43.533Z"
        const [datePart, timePart] = dateStr.split('T');
        const timeOnly = timePart.split('.')[0]; // Bỏ milliseconds và Z
        
        const [year, month, day] = datePart.split('-');
        const [hour, minute] = timeOnly.split(':');
        
        // Format lại theo định dạng Việt Nam với thời gian UTC gốc
        return `${hour}:${minute} ${day}/${month}/${year}`;
      } else {
        // Xử lý format thường: "2025-05-23 13:42:43.533"
        const parts = dateStr.split(' ');
        if (parts.length >= 2) {
          const datePart = parts[0]; // "2025-05-23"
          const timePart = parts[1].split('.')[0]; // "13:42:43"
          
          const [year, month, day] = datePart.split('-');
          const [hour, minute] = timePart.split(':');
          
          return `${hour}:${minute} ${day}/${month}/${year}`;
        }
      }
      
      // Fallback về cách cũ nếu format khác
      const dateObj = new Date(date);
      return dateObj.toLocaleString('vi-VN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });
    } catch (error) {
      console.error('Date parsing error:', error);
      return '-';
    }
  };

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const loadMessages = useCallback(async () => {
    if (!support) return;
    console.log('support', support.FeedbackID);
    try {
      setLoading(true);
      const response = await axiosInstance.get(`${SUPPORT_API.MESSAGES.LIST}/${support.FeedbackID}/feedback`);
      setMessages(response.data?.data || []); // Changed to access data.data
    } catch (error) {
      console.error('Load messages error:', error);
      message.error('Không thể tải tin nhắn');
    } finally {
      setLoading(false);
    }
  }, [support]);


  useEffect(() => {
    loadMessages();
    console.log('loadMessages'.messages);
  }, [loadMessages]);

  useEffect(() => {
    scrollToBottom();
  }, [messages, scrollToBottom]);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

    const handleSend = async () => {
    if (!messageText.trim()) return;

    try {
        await axiosInstance.post(SUPPORT_API.MESSAGES.CREATE(support.FeedbackID), {
            content: messageText.trim()
        });
        setMessageText('');
        await loadMessages();
    } catch (error) {
        message.error('Không thể gửi tin nhắn');
    }
    };

    // Check if the message is from the current user
  const isCurrentUserMessage = (senderId) => senderId === support.UserID;

  return (
    <Modal
      title={`Chi tiết hỗ trợ: ${support?.Tenant.TenantName} - ${support?.Title}`}
      open={visible}
      onCancel={onClose}
      width={windowWidth >= 768 ? 'calc(100vw - 40px)' : '100%'}
      footer={null}
    >
      {/* Support Info Section */}
      <div style={{ marginBottom: 16, padding: 16, background: '#f5f5f5', borderRadius: 8 }}>
        <Text strong>Nội dung: </Text>
        <Text>{support?.Content}</Text>
        <br />
        <Text strong>Ngày tạo: </Text>
        <Text>{formatDate(support?.CreatedAt)}</Text>
      </div>

      <div style={{ height: '50vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ flex: 1, overflowY: 'auto', marginBottom: 16 }}>
          <List
            loading={loading}
            dataSource={messages}
            renderItem={(item) => (
              <List.Item style={{ 
                justifyContent: isCurrentUserMessage(item.SenderID) ? 'flex-start' : 'flex-end',
                padding:10
              }}>
                <div style={{
                  maxWidth: '70%',
                  backgroundColor: isCurrentUserMessage(item.SenderID) ? '#1890ff' : '#f0f0f0',
                  padding: '8px 12px',
                  borderRadius: 8,
                  color: isCurrentUserMessage(item.SenderID) ? '#fff' : 'rgba(0, 0, 0, 0.85)'
                }}>
                  <div>
                    <Avatar size="small" icon={<UserOutlined />} style={{ marginRight: 8 }} />
                    <Text strong style={{ 
                      color: isCurrentUserMessage(item.SenderID) ? '#fff' : 'inherit'
                    }}>
                      {isCurrentUserMessage(item.SenderID) ? support.Tenant?.TenantName : 'Admin'}
                    </Text>
                  </div>
                  <div style={{ marginTop: 4 }}>{item.Content}</div>
                  <div style={{ fontSize: 12, marginTop: 4, opacity: 0.7 }}>
                    {formatDate(item.CreatedAt)}
                  </div>
                </div>
              </List.Item>
            )}
          />
          <div ref={messagesEndRef} />
        </div>

        <div style={{ display: 'flex', gap: 8 }}>
          <Input
            value={messageText}
            onChange={(e) => setMessageText(e.target.value)}
            onPressEnter={handleSend}
            placeholder="Nhập tin nhắn..."
          />
          <Button
            type="primary"
            icon={<SendOutlined />}
            onClick={handleSend}
          >
            Gửi
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default SupportDetail;